/* eslint-disable prettier/prettier -- behoud de afgesproken witregels binnen conditionals. */
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { MeshPhysicalMaterial } from 'three'
import { fetchAssetBuffer, isAbortError, throwIfAborted } from './assetRequests'
import { ModelDRACOLoader } from './dracoLoader'

const originalMaterialsByScene = new WeakMap()

const constructCDNURL = (modelID) => {
  return `https://3dassets.royalbotania.com/models/${modelID}.glb`
}

export function disposeModel(scene, originalMaterials = []) {
  const geometries = new Set()

  const materials = new Set(originalMaterials)

  const textures = new Set()

  const images = new Set()

  const scenes = Array.isArray(scene) ? scene : [scene]

  scenes.forEach((root) => {
    const sourceMaterials = originalMaterialsByScene.get(root)

    sourceMaterials?.forEach((material) => materials.add(material))

    originalMaterialsByScene.delete(root)

    root?.traverse((child) => {
      if (child.geometry) {

        geometries.add(child.geometry)

      }

      const childMaterials = Array.isArray(child.material)
        ? child.material
        : [child.material]

      childMaterials.filter(Boolean).forEach((material) => materials.add(material))
    })
  })

  materials.forEach((material) => {
    Object.values(material).forEach((value) => {
      if (value?.isTexture) {

        textures.add(value)

      }
    })
  })

  textures.forEach((texture) => {
    if (texture.image?.close) {

      images.add(texture.image)

    }

    texture.dispose()
  })

  // embedded GLB-beelden kunnen nog afronden nadat de viewer al verdwenen is.
  images.forEach((image) => image.close())
  materials.forEach((material) => material.dispose())
  geometries.forEach((geometry) => geometry.dispose())
}

export async function loadModel(modelId, setModel, onError, onDone, signal) {
  let gltf

  let dracoLoader

  const originalMaterials = new Set()

  try {

    const url = constructCDNURL(modelId)

    const buffer = await fetchAssetBuffer(url, signal)

    throwIfAborted(signal)

    dracoLoader = new ModelDRACOLoader(signal)

    const loader = new GLTFLoader()
    loader.setDRACOLoader(dracoLoader)

    // gewone GLB's gebruiken geen decoder; lokale parsing kan na abort nog afronden.
    gltf = await loader.parseAsync(buffer, new URL('.', url).href)

    throwIfAborted(signal)

    gltf.scene.traverse((child) => {
      if (child.isMesh) {

        child.castShadow = true
        child.receiveShadow = true

        if (
          child.material &&
          !child.material.name.includes('rubber') &&
          !child.material.name.includes('metal') &&
          !child.material.name.includes('back_material')
        ) {

          originalMaterials.add(child.material)

          child.material = new MeshPhysicalMaterial({
            name: child.material.name,
          })

        }

      }
    })

    if (gltf.animations.length) {

      gltf.scene.userData.animations = gltf.animations

    }

    // bewaar vervangen bronmaterialen ook voor cleanup na een geslaagde promise.
    originalMaterialsByScene.set(gltf.scene, originalMaterials)

    throwIfAborted(signal)

    setModel?.(gltf.scene)

    throwIfAborted(signal)

    onDone?.(gltf.scene)

    return gltf.scene

  } catch (error) {

    if (gltf) {

      disposeModel(gltf.scenes || gltf.scene, originalMaterials)

    }

    if (!signal?.aborted && !isAbortError(error)) {

      console.error('Error loading GLB file:', error)
      onError?.(error)

    }

    throwIfAborted(signal)

    throw error

  } finally {

    await dracoLoader?.release()

  }
}
